const RedCircleTickIcon = ({ height = 14, width = 14, fill = "#F3123C" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_491_80888)">
      <path
        d="M6.43398 9.05898C6.26445 9.23125 5.98555 9.23125 5.81602 9.05898L4.06602 7.30898C3.89375 7.13945 3.89375 6.86055 4.06602 6.69102C4.23555 6.51875 4.51445 6.51875 4.68398 6.69102L6.125 8.13203L9.31602 4.94102C9.48555 4.76875 9.76445 4.76875 9.93398 4.94102C10.1062 5.11055 10.1062 5.38945 9.93398 5.55898L6.43398 9.05898ZM14 7C14 10.8664 10.8664 14 7 14C3.13359 14 0 10.8664 0 7C0 3.13359 3.13359 0 7 0C10.8664 0 14 3.13359 14 7ZM7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_491_80888">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RedCircleTickIcon;
